export const DepositIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5" clipPath="url(#clip0_786_32753)">
      <path
        d="M10.2161 12.5606C10.0541 12.5606 9.89738 12.6279 9.78539 12.7452L8.60944 13.9158V10.216C8.60944 9.87964 8.3358 9.60596 7.99943 9.60596C7.66306 9.60596 7.38942 9.87959 7.38942 10.216V13.9157L6.21136 12.7431C5.97491 12.5068 5.59024 12.5068 5.35388 12.7431C5.23934 12.8576 5.17627 13.0098 5.17627 13.1718C5.17627 13.3337 5.23934 13.486 5.35384 13.6004L7.56848 15.8151C7.68048 15.9325 7.83726 15.9998 7.99943 15.9998C8.16155 15.9998 8.31839 15.9326 8.43038 15.8151L10.6427 13.6028C10.7601 13.491 10.8275 13.3342 10.8275 13.1718C10.8275 13.0107 10.7611 12.855 10.6451 12.7431C10.5332 12.6271 10.3773 12.5606 10.2161 12.5606Z"
        fill="black"
      />
      <path
        d="M14.6498 0H0.60996C0.273637 0 0 0.273637 0 0.60996V7.26053C0 8.00433 0.605197 8.60943 1.34909 8.60943H15.3889C15.7252 8.60943 15.9989 8.33579 15.9989 7.99942V1.34909C15.9988 0.605197 15.3936 0 14.6498 0ZM1.34909 7.38942C1.27789 7.38942 1.21997 7.33159 1.21997 7.26053V1.21997H14.6498C14.721 1.21997 14.7789 1.27789 14.7789 1.34909V7.38942H1.34909Z"
        fill="black"
      />
      <path
        d="M7.99938 2.2168C7.15181 2.2168 6.39464 2.7227 6.07044 3.50561C5.746 4.28866 5.92371 5.18183 6.52304 5.78092C6.92339 6.18141 7.45484 6.39362 7.99711 6.39362C8.26647 6.39362 8.53852 6.34123 8.79835 6.23356C9.58126 5.90936 10.0872 5.15219 10.0872 4.30458C10.0872 3.15336 9.1506 2.2168 7.99938 2.2168ZM8.86719 4.30458C8.86719 4.78311 8.4779 5.1724 7.99938 5.1724C7.64713 5.1724 7.33241 4.96212 7.19761 4.63667C7.06276 4.31112 7.13651 3.93997 7.38561 3.69101C7.55207 3.52456 7.77308 3.43633 7.99851 3.43633C8.11046 3.43633 8.22346 3.45808 8.33142 3.50282C8.65691 3.63766 8.86719 3.95234 8.86719 4.30458Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_786_32753">
        <rect width="15.9988" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
